/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { isMobileOnly } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper/core";
import "swiper/swiper.min.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";

import { siteUrl } from "../../utils/constants";
import { StrapiMedia } from "../../types/strapi";
import { mediaUrl } from "../../utils/imageUtils";
import ImageLightbox from "../common/ImageLightbox";

// install Swiper modules
SwiperCore.use([Autoplay, EffectFade, Pagination, Navigation]);

interface ImagesCarouselProps {
  images?: StrapiMedia[];
  cssClass?: string;
  toTop?: boolean;
}

const ImagesCarousel = ({
  images,
  cssClass = "mb--40",
  toTop,
}: ImagesCarouselProps) => {
  const [status, setStatus] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    if ((isOpen || toTop) && status) {
      setStatus(0);
    }
  }, [isOpen, toTop, status]);

  const changeStatusPhotoIndex = (value: number) => {
    if (value >= 0) {
      setPhotoIndex(value);
      setIsOpen(true);
    }
  };

  const imagesList =
    images && Array.isArray(images) && isMobileOnly
      ? images.map((item) =>
          Object.keys(item).length !== 0
            ? mediaUrl(item.formats.medium.url)
            : ""
        )
      : images && Array.isArray(images)
      ? images.map((item) => mediaUrl(item.url))
      : "";

  const imagesCaptionList =
    images && Array.isArray(images)
      ? images.map((item) => item.caption)
      : "";

  return (
    <div className={`container  ${cssClass}`}>
      <div className="row">
        <div className="col-lg-12">
          <div className="inner-wrapper">
            <div className="inner">
              {images && Array.isArray(images) ? (
                <Swiper
                  spaceBetween={30}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  className="mySwiper"
                  effect="fade"
                  centeredSlides
                  grabCursor
                  loop
                >
                  {images.map((image, index) => (
                    <SwiperSlide key={`home-carousel${index}`}>
                      <button
                        type="button"
                        onClick={() => changeStatusPhotoIndex(index)}
                        onWheel={
                          status
                            ? () => changeStatusPhotoIndex(index)
                            : changeStatusPhotoIndex()
                        }
                        onMouseEnter={
                          status
                            ? () => changeStatusPhotoIndex(index)
                            : changeStatusPhotoIndex()
                        }
                        onKeyDown={() => changeStatusPhotoIndex(index)}
                        tabIndex={0}
                      >
                        {isMobileOnly &&
                        image?.formats !== undefined ? (
                          <img
                            src={mediaUrl(image?.formats.small.url)}
                            alt=""
                          />
                        ) : (
                          <img
                            src={mediaUrl(image?.url)}
                            alt=""
                          />
                        )}
                      </button>
                    </SwiperSlide>
                  ))}
                  <ImageLightbox
                    open={isOpen}
                    images={Array.isArray(imagesList) ? imagesList : []}
                    captions={Array.isArray(imagesCaptionList) ? imagesCaptionList : []}
                    index={photoIndex}
                    onClose={() => setIsOpen(false)}
                    onIndexChange={setPhotoIndex}
                  />
                </Swiper>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagesCarousel;
